
import React, {  useState } from 'react'
import QRCode from "react-qr-code";


import styles from './BottomMenu.module.css';


const baseUrl = "https://ar-configurator-3d.herokuapp.com/";



function adjust(color, amount) {
    return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

function ColorButton({ property, color, materials, variant, instance, option, setColor}) {

    function _setColor(id, value) {
     //   materials[id].color.set(value);
        setColor(variant, option);
    }

    var currentOption = instance[variant.id].id;

    var currentOptionExtraPrice = instance[variant.id].extra_price ? instance[variant.id].extra_price : 0;
    var optionExtraPrice = option.extra_price ? option.extra_price : 0;
    var difference = optionExtraPrice-currentOptionExtraPrice;

    var borderColor = adjust(color, -60);
    

    return (
        <svg viewBox="-4 -4 54 54" width="58" height="58" className={(option.id === currentOption ? '': styles.clickable)}>
            <g>
                <circle className={styles.shadow} onClick={() => _setColor(property, color)}
                    stroke={borderColor} strokeWidth={option.id===currentOption ? .5 : 0.5} cx={25} cy={25} r={option.id===currentOption ? 23 : 16} fill={color}/>
                <text x="25" y="28" textAnchor='middle' style={{fontSize: '.6em', fill: option.color_contrast ? option.color_contrast : '#fff'}}>{currentOptionExtraPrice !== optionExtraPrice ? difference > 0 ? '+€'+difference : '-€'+(-1*difference) : ""}</text>
            </g>
        </svg>
    );
}


export default function BottomMenu({ instance, configuration, gltf, setEnv, setColor, price }) {

    var [currentTab, setCurrentTab] = useState("env");


    var qr_url = baseUrl;
    console.log("Qr: " + qr_url);

    return (
        <div className="menu">

            <div className="columns is-vcentered is-mobile columnsvertical" style={{'alignItems': 'stretch' }}>
                <div className="column is-three-quarters has-text-center">
                    <div className="tabs is-centered pb-1 mb-2">
                        <ul>
                            <li key={"env"} className={currentTab === 'env' ? 'is-active' : ''} ><a onClick={() => { setCurrentTab("env") }}>Omgeving</a></li>
                            {configuration.variants.map((variant) => (
                                <li key={variant.id} className={currentTab === variant.id ? 'is-active' : ''}><a onClick={() => { setCurrentTab(variant.id) }}>{variant.label}</a></li>
                            ))}
                        </ul>
                    </div>
                    <div className="mt-2 pb-2 mb-2">
                        {
                            currentTab === "qr" ?
                                (
                                    <div className="columns is-vcentered mb-0">
                                        <div className="column has-text-centered">
                                            Bekijk de step op uw mobiel via deze QR Code!

                                        </div>
                                        <div className="column has-text-centered is-vcentered is-mobile">
                                            <QRCode value={qr_url} size={100} />
                                        </div>

                                    </div>

                                )
                                : (<></>)
                        }
                        {currentTab === "env" ? (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                {configuration.environments.map((env) => (
                                <svg viewBox="-29 -29 58 58" width="58" height="58" className={(instance.env && instance.env.id === env.id ? '': styles.clickable)}>
                                    <defs>
                                        <rect id="rect-s" width={32} height={32} rx="50%"/>
                                        <clipPath id="clip-s">
                                            <use xlinkHref="#rect-s"/>
                                        </clipPath>
                                        <rect id="rect-l" width={46} height={46} rx="50%"/>
                                        <clipPath id="clip-l">
                                            <use xlinkHref="#rect-l"/>
                                        </clipPath>
                                    </defs>
                                    <g transform={'translate('+(instance.env && instance.env.id === env.id ? -23 : -16) +','+(instance.env && instance.env.id === env.id ? -23 : -16) +')'}>
                                        <image clipPath={'url('+(instance.env && instance.env.id === env.id ?"#clip-l": "#clip-s" )+')'} href={baseUrl + env.thumbnail} width={instance.env && instance.env.id === env.id ? 46 : 32}  height={instance.env && instance.env.id === env.id ? 46 : 32} onClick={() => { setEnv(env) }}/>
                                     </g>
                                </svg>


                                    
                                
                                ))}
                                <svg viewBox="-4 -4 58 58" width="58" height="58" className={(instance.env ? styles.clickable : '')}>
                                    <g >
                                        <circle className={styles.shadow} onClick={() => setEnv(null)}
                                            stroke="gray" strokeWidth=".5" cx={25} cy={25} r={instance.env ? 16 : 23} fill="#fff" strokeDasharray="4" />
                                    </g>
                                </svg>

                            </div>
                        ) : (configuration.variants.map((variant) => (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                {
                                    variant.id === currentTab ?
                                        variant.options.map((option) => (
                                            <ColorButton instance={instance} variant={variant} option={option} materials={gltf.materials} property={option.material} color={option.color} setColor={setColor} />
                                        ))
                                        : (<></>)
                                }
                            </div>
                        )))}
                    </div>
                </div>
                <div className="column is-one-quarter has-text-right is-vcentered" style={{'display': 'flex'}}>
                    <div className="mb-2 bestel is-hidden-mobile" style={{'marginTop': 'auto', 'marginLeft': 'auto'}}>
                        <span style={{ fontSize: '1.8em' }}>&euro;{price}</span> &nbsp; <button className="button is-link m-1" onClick={() =>{ alert("Die bestelknop is voor de sier. Dit is immers een demo. Maar hij is met elke webshop te koppelen, daar gaat het om.");}}>Bestel</button>
                    </div>
                    <div className="mb-2 bestel is-hidden-tablet" style={{'marginTop': 'auto', 'marginLeft': 'auto'}}>
                        <span style={{ fontSize: '1.2em' }}>&euro;{price}</span> &nbsp; <button className="button is-small is-link m-1" onClick={() =>{ alert("Die bestelknop is voor de sier. Dit is immers een demo. Maar hij is met elke webshop te koppelen, daar gaat het om.");}}>Bestel</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

//style={{'display':'flex', 'flexDirection':'column', 'justifyContent':'space-between'}}


// <img key={env.id} className={styles.thumbnail +' ' + (instance.env && instance.env.id ===env.id ? '': styles.clickable)} 
//style={{margin: instance.env && instance.env.id === env.id ? 2:12}} 
//src={baseUrl + env.thumbnail} width={instance.env && instance.env.id === env.id ? 50 : 35} onClick={() => { setEnv(env) }} />
                                